import React, { useEffect, useState } from "react";
import { getProfileData } from "../../../service/employerapi";
import { getJobseekerProfileData } from "../../../service/api";

const Header = () => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      if (!token || !role) return;

      try {
        if (role === "job_seeker") {
          const res = await getJobseekerProfileData();
          setUser(res.data?.data || res.data || {});
        } else if (role === "employer") {
          const res = await getProfileData();
          setUser(res.data?.data || res.data || {});
        }
      } catch (err) {
        console.error("Failed to fetch profile:", err);
      }
    };

    fetchProfile();
  }, [token, role]);

  return (
    <section
      className="headerSection wow animate__fadeIn"
      data-wow-delay="0.2s"
    >
      <div className="site-width">
        <div className="headerWrapper">
          <div className="logoSection wow animate__fadeInLeft">
            <a href="/">
              <img
                src={`${process.env.PUBLIC_URL}/assets/img/logo-light.svg`}
                alt="Hourlee"
                title="Hourlee"
                oncontextmenu="return false;"
              />
            </a>
          </div>
          <div className="headerMain wow animate__fadeInRight">
            <div className="mainHeader">
              <div className="allHeaders wow animate__fadeIn">
                <div className="mainHeaderSection">
                  <div className="headerNav">
                    <ul className="headerMenu">
                      <li className="hasSub megaMenu">
                        <a href="/job-list">
                          <img
                            src={`${process.env.PUBLIC_URL}/assets/img/icons/jobs.svg`}
                            alt="chat"
                            style={{ marginRight: "5px" }}
                          />{" "}
                          Find Jobs
                        </a>
                        <div className="headerSubNav">
                          <ul className="headerSubMenu">
                            <li>
                              <h5>Popular Jobs</h5>
                            </li>
                            <li>
                              <a href="/job-category/68a4c4e79461d1229ede72dd">
                                Information Technology
                              </a>
                            </li>
                            <li>
                              <a href="/job-category/691c42390e6acd70550a8638">
                                Healthcare & Medical
                              </a>
                            </li>
                            <li>
                              <a href="/job-category/691c41bd0e6acd70550a861d">
                                Finance & Accounting
                              </a>
                            </li>
                            <li>
                              <a href="/job-category/691c424d0e6acd70550a8641">
                                Manufacturing & Production
                              </a>
                            </li>
                            <li>
                              <a href="/job-category/691c42960e6acd70550a8647">
                                Retail & E-Commerce
                              </a>
                            </li>
                            <li>
                              <a href="/job-category/691c418f9370b0ec873051f9">
                                Human Resource
                              </a>
                            </li>
                          </ul>
                          <ul className="headerSubMenu">
                            <li>
                              <h5>Jobs in demand</h5>
                            </li>
                            <li>
                              <a href="/job-list?jobType=Full+Time+On-Site">
                                Fresher jobs
                              </a>
                            </li>
                            <li>
                              <a href="/job-list?jobType=Contractual">
                                Contractual jobs
                              </a>
                            </li>
                            <li>
                              <a href="/job-list?jobType=Full-time-remote">
                                Remote jobs
                              </a>
                            </li>
                            <li>
                              <a href="/job-list?jobType=Part+Time+Remote">
                                Part Time Remote jobs
                              </a>
                            </li>
                            <li>
                              <a href="/job-list?jobType=Full+Time+On-Site">
                                On Site jobs
                              </a>
                            </li>
                            <li>
                              <a href="/job-list?jobType=Full-time-remote">
                                Full Time jobs
                              </a>
                            </li>
                          </ul>
                          <ul className="headerSubMenu">
                            <li>
                              <h5>Jobs by location</h5>
                            </li>
                            <li>
                              <a href="/job-list?city=New+Delhi">
                                Jobs in Delhi
                              </a>
                            </li>
                            <li>
                              <a href="/job-list?city=Mumbai">Jobs in Mumbai</a>
                            </li>
                            <li>
                              <a href="/job-list?city=Bengaluru">
                                Jobs in Bangalore
                              </a>
                            </li>
                            <li>
                              <a href="/job-list?city=Hyderabad">
                                Jobs in Hyderabad
                              </a>
                            </li>
                            <li>
                              <a href="/job-list?city=Chennai">
                                Jobs in Chennai
                              </a>
                            </li>
                            <li>
                              <a href="/job-list?city=Pune">Jobs in Pune</a>
                            </li>
                          </ul>
                        </div>
                      </li>
                      <li className="hasSub megaMenu">
                        <a href="/job-category">
                          <img
                            src={`${process.env.PUBLIC_URL}/assets/img/icons/explore.svg`}
                            alt="chat"
                            style={{ marginRight: "5px" }}
                          />
                          Explore Job Categories
                        </a>
                        <div className="headerSubNav">
                          <ul className="headerSubMenu">
                            <li>
                              <h5>Popular Jobs</h5>
                            </li>
                            <li>
                              <a href="/job-category/68a4c4e79461d1229ede72dd">
                                Information Technology
                              </a>
                            </li>
                            <li>
                              <a href="/job-category/691c42390e6acd70550a8638">
                                Healthcare & Medical
                              </a>
                            </li>
                            <li>
                              <a href="/job-category/691c41bd0e6acd70550a861d">
                                Finance & Accounting
                              </a>
                            </li>
                            <li>
                              <a href="/job-category/691c424d0e6acd70550a8641">
                                Manufacturing & Production
                              </a>
                            </li>
                            <li>
                              <a href="/job-category/691c42960e6acd70550a8647">
                                Retail & E-Commerce
                              </a>
                            </li>
                            <li>
                              <a href="/job-category/691c418f9370b0ec873051f9">
                                Human Resource
                              </a>
                            </li>
                          </ul>
                          <ul className="headerSubMenu">
                            <li>
                              <h5>Browse Categories</h5>
                            </li>
                            <li>
                              <a href="/job-category/691c421f0e6acd70550a862f">
                                Design & Creative
                              </a>
                            </li>
                            <li>
                              <a href="/job-category/691c41170e6acd70550a861a">
                                Digital Marketing
                              </a>
                            </li>
                            <li>
                              <a href="/job-category/691c422f0e6acd70550a8635">
                                Education & Teaching
                              </a>
                            </li>
                            <li>
                              <a href="/job-category/691c43c60e6acd70550a867a">
                                Energy, Oil & Gas
                              </a>
                            </li>
                            <li>
                              <a href="/job-category/691c439a0e6acd70550a866b">
                                Event Management
                              </a>
                            </li>
                            <li>
                              <a href="/job-category/691c43a10e6acd70550a866e">
                                Films & Entertainment
                              </a>
                            </li>
                          </ul>
                          <ul className="headerSubMenu">
                            <li>
                              <h5>Browse Categories</h5>
                            </li>
                            <li>
                              <a href="/job-category/691c43b10e6acd70550a8674">
                                Fitness & Wellness
                              </a>
                            </li>
                            <li>
                              <a href="/job-category/691c42390e6acd70550a8638">
                                Healthcare & Medical
                              </a>
                            </li>
                            <li>
                              <a href="/job-category/691c42d30e6acd70550a865f">
                                Hospitality & Tourism
                              </a>
                            </li>
                            <li>
                              <a href="/job-category/691c43b90e6acd70550a8677">
                                Interior Design
                              </a>
                            </li>
                            <li>
                              <a href="/job-category/691c42c10e6acd70550a8659">
                                Legal & Compliance
                              </a>
                            </li>
                            <li>
                              <a href="/job-category/691c424d0e6acd70550a8641">
                                Manufacturing & Production
                              </a>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="headerButns">
                <div className="headerRightMenuWrap">
                  <ul className="headerRightMenu headerMenu">
                    {token && role ? (
                      <>
                        {role === "job_seeker" && (
                          <li>
                            <div className="defaultBtn">
                              <a
                                href="/jobseeker/dashboard"
                                className="loginbtn registerBtn d-flex align-items-center gap-2 d-flex"
                                style={{ padding: "3px 20px" }}
                              >
                                <img
                                  src={`${process.env.PUBLIC_URL}/assets/img/user1.jpg`}
                                  alt="User"
                                  style={{ objectFit: "cover" }}
                                />
                                <div>
                                  <div className="userName">
                                    {user?.name || "User"}
                                  </div>
                                  <div className="headerCareer">Dashboard</div>
                                </div>
                              </a>
                            </div>
                          </li>
                        )}

                        {role === "employer" && (
                          <li>
                            <div className="defaultBtn">
                              <a
                                href="/employer/dashboard"
                                className="loginbtn registerBtn d-flex align-items-center gap-2 d-flex"
                                style={{ padding: "3px 20px" }}
                              >
                                <img
                                  src={`${process.env.PUBLIC_URL}/assets/img/user2.jpg`}
                                  alt="Company"
                                  style={{ objectFit: "cover" }}
                                />
                                <div>
                                  <div className="userName">
                                    {user?.companyName || "Employer"}
                                  </div>
                                  <div className="headerCareer">Dashboard</div>
                                </div>
                              </a>
                            </div>
                          </li>
                        )}
                      </>
                    ) : (
                      <>
                        <li>
                          <div className="defaultBtn">
                            <a
                              href="/jobseeker/login"
                              className="loginbtn registerBtn"
                            >
                              <span className="headerCareer">Sign In </span>
                            </a>
                          </div>
                        </li>
                        <li>
                          <a href="/employer/home">For Employers</a>
                        </li>
                      </>
                    )}
                  </ul>
                </div>
              </div>
            </div>
            <div className="hamburger is-md">
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Header;
